import { c as _c } from "react/compiler-runtime";
import { useSupporterDetails } from '@sola/supporter-sdk/hooks/details.ts';
import { getSupporterEmail, getSupporterFullName, getSupporterInitials } from '@sola/supporter-sdk/utils/name-format.ts';
type SupporterIdentityDetails = {
  email?: string;
  initials?: string;
  name?: string;
};
export const useSupporterIdentity = () => {
  const $ = _c(10);
  const {
    data: supporter
  } = useSupporterDetails();
  let t0;
  if ($[0] !== supporter) {
    t0 = getSupporterEmail(supporter);
    $[0] = supporter;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== supporter) {
    t1 = getSupporterInitials(supporter);
    $[2] = supporter;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== supporter) {
    t2 = getSupporterFullName(supporter);
    $[4] = supporter;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = {
      email: t0,
      initials: t1,
      name: t2
    };
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};